<template>
 <div>
      <b-row>
              <b-col md="6">
                <b-form-group label="Já se tentou inscrever anteriormente?">
                  <b-form-radio-group
                    id="radio-slots"
                    v-model="value.previous_tries_check"
                    :options="yesNoOptions"
                    name="radio-options-slots"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Quantas Vezes"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                  v-if="value.previous_tries_check == 1"
                >
                  <b-form-group
                    label="Quantas vezes tentou inscrever-se anteriormente?"
                  >
                    <b-form-input
                      id="previous_tries"
                      type="number"
                      step="1"
                      name="previous_tries"
                      v-model="value.previous_tries"
                      :state="validateState(validationContext)"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
 </div>
</template>
<script>
import Base from './base'
export default  {
  name: "CamtilForm",
  extends: Base
};
</script>
